import tw from "twin.macro";

export const InlineWrapper = tw.div`
	flex-1
	min-w-[min(20rem,100vw)]
    md:box-content
    px-24
`;
